import { ContactActivityResponse } from '@business/entities/contact';
import {
  EmailPreviewResponse,
  GmailMessageId,
  GmailMessageResponse,
  PreviewEmailRequest,
  SendEmailRequest,
  SendTestEmailRequest,
} from '@business/entities/gmail_messages';
import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';
export function fetchEmail(id: GmailMessageId) {
  return Endpoint.get<GmailMessageResponse>(`@gc/mail/email/${id}`, {});
}

export function sendEmail(data: SendEmailRequest) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<ContactActivityResponse>(`@gc/mail`, { formData, hasFiles: true });
}

export function sendReply(id: GmailMessageId, data: SendEmailRequest) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<GmailMessageResponse>(`@gc/mail/reply/${id}`, { formData, hasFiles: true });
}

export function previewEmail(data: PreviewEmailRequest) {
  return Endpoint.post<EmailPreviewResponse[]>(`@gc/mail/preview`, { data });
}

export function sendTestEmail(data: SendTestEmailRequest) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<{ sentTo: string }>(`@gc/mail/test`, { formData, hasFiles: true });
}
